import React from 'react';
import { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';

import BankAccountNumberInput from './BankAccountNumberInput';

const InputBankAccountNumber = ({ name = 'accountNumber' }) => (
  <ValidatedTextField
    name={name}
    control={useFormContext().control}
    rules={{
      required: 'This field is required.',
      validate: (v) => (v?.length >= 3 && v?.length <= 18) || 'Please enter a valid Account Number.',
    }}
  >
    <TextField
      fullWidth
      label="Account Number"
      InputProps={{ inputComponent: BankAccountNumberInput }}
    />
  </ValidatedTextField>
);

export default InputBankAccountNumber;
